import { getCookie } from './cookies';

/**
 * Clears authentication cookies by setting them to expire in the past
 * @private
 */
const clearAuthCookies = (): void => {
	const expiredDate = 'Thu, 01 Jan 1970 00:00:00 GMT';
	document.cookie = `jwt=; expires=${expiredDate}; path=/`;
	document.cookie = `refreshToken=; expires=${expiredDate}; path=/`;
};

/**
 * Syncs JWT tokens from cookies to localStorage with validation
 * Enables seamless login bypass when cookies are set by the backend
 * @returns {boolean} True if tokens were successfully synced, false otherwise
 */
export const syncCookiesToLocalStorageWithValidation = (): boolean => {
	const jwtCookie = getCookie('jwt');
	const refreshTokenCookie = getCookie('refreshToken');
	if (!jwtCookie || !refreshTokenCookie) {
		return false;
	}

	try {
		const parts = jwtCookie.split('.');
		if (parts.length !== 3) {
			console.warn('Invalid JWT format in cookie');
			return false;
		}
		const payload = JSON.parse(atob(parts[1]));
		const currentTime = Math.floor(Date.now() / 1000);
		if (payload.exp && payload.exp < currentTime) {
			console.warn('JWT in cookie has expired');
			return false;
		}
		localStorage.setItem('jwt', jwtCookie);
		localStorage.setItem('refreshToken', refreshTokenCookie);
		clearAuthCookies();
		return true;
	} catch (error) {
		console.error('Error validating JWT from cookie:', error);
		return false;
	}
};

